<template>
  <div class="container page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
  
    <div class="main">
   
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="item_list" v-for="(v,key) in list" :key="key">
          <div class="lottery_info">
            <van-image class="cover" :src="v.lottery.ico">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <span class="period-number">{{v.expect}}</span>
            <span class="period-number">{{v.lottery.name}}</span>
          </div>
          <div class="recent" >
            <div class="kuaisan-ball left">
            <div v-if="v.status !== 0">
              <span>{{$t("reservation.result")}}</span>
              <span class="ressquareBox">{{ v.size }}</span>
              <span class="ressquareBox">{{ v.double }}</span>
             
            </div>
          
            </div>
          </div>
          <div class="topInfo">
        
            <span v-if="v.status === 1" style="color: #07c160">{{v.status_text}}</span>
            <span v-else>{{v.status_text}}</span>
            <span>{{$t("reservation.money")}}：{{v.money}}</span>
          </div>
        <div class="topInfo">
            <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
            <span v-else >{{v.win_text}}</span>
            <span>{{v.profit}}</span>
          </div>
          <div class="topInfo">
            <span>{{ $t('reservation.curr_choose') }}</span>
            <span v-if="v.type=='big' || v.type=='small' ||v.type=='one' || v.type=='two'" class="ressquareBox">{{splitType(v.type,0)}}</span>
            <template v-else >
              <span class="ressquareBox">{{ splitType(v.type,0) }}</span>
              <span class="ressquareBox">{{ splitType(v.type,1) }}</span>              
            </template>

          </div>
          <div class="time">
            <span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
          </div>
          <div class="time">
            <span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      sum: '',
      double: '',
      size:""
      
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    splitType(type, index) {
      // 分割字符串并返回指定索引的值
      let t =  '';
      const lanng = localStorage.getItem("lang");
      switch(type.split('_')[index]){
        case "big":
          lanng == 'zh'? t = '蘿莉少女':lanng == 'en'? t = 'Sexy':lanng == 'ja'? t = 'バラは': t= '귀여운';
          break;
        case "small":
          lanng == 'zh'? t = '人妻少婦':lanng == 'en'? t = 'Lovely':lanng == 'ja'? t = "リリー·リリー":t = '섹시한'
          break;
        case "two":
        lanng == 'zh'? t = "明星網紅":lanng == 'en'? t = "Beautiful":lanng == 'ja'? t = "气球":t = "순종적";
          break;
        case "one":
        lanng == 'zh'? t = "性感模特":lanng == 'en'? t = "Passionate":lanng == 'ja'? t = "花火大会": t = "에스엠";
          break;
      }
      return t;


    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        console.log('user_get_game_list',res)
        if(res.code === 200){
          const lanng = localStorage.getItem("lang");
          this.list = res.data;
          const lang = localStorage.getItem("lang");
          this.list.forEach(item => {
            if(item.status !== 0){
              let sum = item.opencode[0] + item.opencode[1] + item.opencode[2];
              console.log('num,sum,item.type',item.num,sum,item.type)
              if(sum >= 11 && sum <=18){
                item['size'] = lanng == 'zh'? '蘿莉少女':lanng == 'en'?  'Sexy':lanng == 'ja'?  'バラは': '귀여운'
              }else if(sum >= 3 && sum <= 10){
                item['size'] =  lanng == 'zh'? '人妻少婦':lanng == 'en'? 'Lovely':lanng == 'ja'?  "リリー·リリー": '섹시한'
              }
              if(sum % 2 === 0){
                item['double'] = lanng == 'zh'?  "明星網紅":lanng == 'en'?  "Beautiful":lanng == 'ja'?  "气球": "순종적";
              }else {
                item['double'] = lanng == 'zh'? "性感模特":lanng == 'en'? "Passionate":lanng == 'ja'? "花火大会": "에스엠";
              }
            }
      
            const parts = item.lottery.name.split(",");
            item.lottery.name =  lang == "kr" ?  parts[0] : lang == "en" ? parts[1] : lang == "ja" ? parts[2] : parts[3];
        
          })
         console.log(this.size, this.double,998);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }

  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserGameList();
    }
  },
  
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #000;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{

}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list  .period-number{
  margin-left: 45px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 32px;
  font-weight: 700;
  color: #000;
}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 100px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 35px;
}
.ressquareBox{
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    border-radius: 16px;
    margin-left: 20px;
    padding:  13px 40px;
    min-width: 13vw;
}
</style>
